export default {
    viewState: {
        baromoney: {
            baromoneyWithdraw: {
                isInProgress: true,
            },
        },
        tabs: {
            activeTabIndex: 0,
        },
        selectedNavItem: '',
        currentPageName: '',
        isSearchOpened: false,
        searchQuery: null,
        pageTitle: '',
    },
    fetching: 0,
    isPending: false,
    appTickCount: 0,
};
